import type { ReactNode } from 'react';

import {
  radioDescription,
  radioError,
  radioGroupRoot,
  radioLabel,
  radioRoot,
} from '@mage-ui/styled-system/recipes';
import { Group as MantineGroup, Radio as MantineRadio } from '@mantine/core';

export type RadioGroupProps = {
  label?: ReactNode;
  error?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  value?: string;
  name?: string;
  onChange?: (value: string) => void;
  classNames?: {
    root?: string;
    radio?: string;
    icon?: string;
    inner?: string;
    body?: string;
    labelWrapper?: string;
    label?: string;
    description?: string;
    error?: string;
    groupRoot?: string;
  };
};

export const RadioGroup = ({
  classNames,
  children,
  ...props
}: RadioGroupProps): ReactNode => {
  return (
    <MantineRadio.Group
      classNames={{
        root: classNames?.root ?? radioRoot(),
        label: classNames?.label ?? radioLabel(),
        description: classNames?.description ?? radioDescription(),
        error: classNames?.error ?? radioError(),
      }}
      {...props}
    >
      <MantineGroup
        classNames={{
          root: classNames?.groupRoot ?? radioGroupRoot(),
        }}
      >
        {children}
      </MantineGroup>
    </MantineRadio.Group>
  );
};

RadioGroup.displayName = 'Radio.Group';
